export const changeLanguage = (i18n, lang) => {
  localStorage.setItem("default-lg", lang);
  i18n.changeLanguage(lang);
  document.documentElement.setAttribute("lang", lang);
  document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
  window.location.reload();
};
